import { windowatch } from '../../../scripts/lib/windowatch';

export default class Credits {

  constructor ($el) {
    this.$el = $el;

    // Slide options
    this.animOffset = 200; // Greater values advance the starting of the animation
    this.animSpeed = 50; // Higher values increase speed

    // Internal values and states
    this.initialized = false;
    this.started = false;
    this.paused = false;
    this.animStart = null;
    this.animID = null;
    this.slideHeight = 0;
    this.oldTop = 0;

    // collect items
    this.$slideWrapper = $el.querySelector('.module-credits__slide-wrapper');
    this.$slide = $el.querySelector('.module-credits__slide');

    this.$control = $el.querySelector('.module-credits__control');
    this.$controlButtons = [...$el.querySelectorAll('.module-credits__control-button')];

    // bind button events
    this.$controlButtons.forEach((item, index) => {
      this.$controlButtons[index].addEventListener('click', this.onControlClick.bind(this));
    });

    // Set fixed height for the wrapper and save the slide height
    this.$slideWrapper.style.height = this.$slideWrapper.offsetHeight + 'px';
    this.slideHeight = this.$slide.offsetHeight;

    // bind scroll and resize events
    windowatch.addScrollListener(this.onScroll.bind(this));
  }

  onScroll (scroll) {
    // Calculate needed distances
    let viewPortBottom = scroll + window.innerHeight;
    let elBottom = this.$el.offsetTop + this.$el.offsetHeight;

    if (
      // This statement checks if the credits module enters the viewport and
      // neither started nor paused
      scroll + this.animOffset  >= this.$el.offsetTop // bottom of viewport - offset is below module top
      && !(scroll > elBottom) // top of viewport not below element
      && !this.started
      && !this.paused
    ) {

      // Start or resume the slider
      if (this.initialized) {
        this.resumeSlider();
      } else {
        this.startSlider();
      }

    } else if (
      // This statement checks if the credits module leaves the viewport to the top or bottom
      scroll > elBottom // top of viewport below element
      || viewPortBottom < this.$el.offsetTop // bottom of viewport above element
    ) {

      // Stop the slider
      this.stopSlider();

    }
  }

  startSlider () {
    this.started = true;
    this.initialized = true;

    this.$slide.style.animationDuration = ((this.slideHeight / this.animSpeed) * 2) + 's';

    // Start the animation
    this.startAnimation();
  }

  resumeSlider () {
    // Set state to started, start animation
    this.started = true;
    this.startAnimation();
  }

  stopSlider () {
    if (this.started) {
      // If started, set state to stopped and cancel animation
      this.started = false;
      this.$slide.style.animationPlayState = 'paused';
    }
  }

  startAnimation () {
    this.$slide.style.animationPlayState = 'running';
  }

  // Button handling
  onControlClick (evt) {
    evt.preventDefault();

    // Switch the paused state
    this.paused = !this.paused;

    // Toggle the paused class for
    this.$control.classList.toggle('module-credits__control--paused');

    if (this.started) {
      // Stop the slide if started..
      this.stopSlider();
    } else {
      // ..otherwise resume playing
      this.resumeSlider();
    }
  }
}
